<template>
  <div class="integralDetailed">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table
            border
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="created_at"
              label="操作時間">
            </el-table-column>
            <el-table-column
              prop="points"
              label="積分">
            </el-table-column>
            <el-table-column
              label="備註">
              <template slot-scope="scope">
                <span v-if="scope.row.order_sn">
                  <span v-if="scope.row.points > 0">(訂單號：{{scope.row.order_sn}}) 購買商品贈送</span>
                  <span v-else>(訂單號：{{scope.row.order_sn}}) 商城消費</span>
                </span>
                <span v-else>
                  <span v-if="scope.row.points > 0"> 商城管理員贈送 </span>
                  <span v-else> 商城管理員减少</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="all" style="text-align: right;">
            您當前的可用積分為：   <span>{{totalIntegral}}</span>  總計 {{tableData.length}} 個記錄
          </div>
        </div>
        <!--分页-->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize">
        </el-pagination>
      </div>
    </div>
    </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  import {pointDetailed} from '@/api/other'
  import {userInformation} from '@/api/authentication';
  export default {
    name: 'IntegralDetailed',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'積分明細',
        num:0,
        page:1,
        total:0,//总页数
        pageSize:0,//每页显示个数
        tableData: [],
        totalIntegral:0
      }
    },
   created(){
     this.geiPoList(this.page)
     this.getInformation()
     window.scrollTo(0,0)
   },
    methods:{
       geiPoList(page){ // 获取积分明细
         pointDetailed(page).then(res =>{
           this.tableData = res.data.data
           this.total = res.data.meta.pagination.total;
           this.pageSize = res.data.meta.pagination.per_page;
         })
       },
      /*获取剩余积分*/
      getInformation(){
        userInformation().then(res =>{
          this.totalIntegral = res.data.user_points;
        })
      },
      handleSizeChange(val) {
      },
      handleCurrentChange(val) {
        this.geiPoList(val)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.all{
  text-align: right;
  span{
    margin: 0 20px;
    color: #0055a0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/IntegralDetailed.vue